// packages/shared-hooks/src/lead-activity/keys.ts
//
// Query-key factory for the CRM Lead activity capsule (#1085) which
// covers three sibling reads — the paginated activity feed, the
// comments list, and the files list — all scoped under a single leadId.
// Every mutation that emits an audit row (create/update comment,
// upload/delete file) MUST invalidate the matching `forLead(leadId)`
// prefix so the feed and the per-resource list stay coherent.
export const leadActivityKeys = {
  all: ['lead-activity'] as const,
  forLead: (leadId: string) => ['lead-activity', leadId] as const,
  feed: (leadId: string) => ['lead-activity', leadId, 'feed'] as const,
  // WHY (#2317 D-8): the header-opt-in feed (task cancel/reopen rows visible)
  // caches under a DISTINCT `'v2'` slot so it never shares a slot with the
  // default read. It sits under the `feed(leadId)` prefix, so a cancel/reopen
  // that invalidates `feed(leadId)` flushes both the default and the v2 slots.
  feedV2: (leadId: string) => ['lead-activity', leadId, 'feed', 'v2'] as const,
  comments: (leadId: string) => ['lead-activity', leadId, 'comments'] as const,
  files: (leadId: string) => ['lead-activity', leadId, 'files'] as const,
};
